module.exports = __webpack_public_path__ + "static/media/turbine_CAD 2.1ed96009.png";